module.exports = __webpack_public_path__ + "static/img/bg__building-streetlight.38388e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg__building-streetlight.png
// module id = kMla
// module chunks = 1